// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"1b73ea90","132":"d3b8575b","192":"d3454315","238":"0cd34e56","437":"1235d457","633":"3e6728df","683":"0d469069","713":"6cdae2ac","755":"645f5b88","908":"32c6d05c"}[chunkId] + ".chunk.js";
};